import { useLayoutEffect, useState, type CSSProperties, type RefObject } from 'react';

// Render beside the Study scrolling main. A portal also avoids clipping by lab cards.
export function useToolTutorDock(host: RefObject<HTMLElement>, open: boolean) {
  const [target, setTarget] = useState<HTMLElement | null>(null);
  const [style, setStyle] = useState<CSSProperties>({});
  useLayoutEffect(() => {
    if (!open) return;
    const shell = host.current?.closest<HTMLElement>('.study-shell');
    const lab = host.current?.closest<HTMLElement>('main');
    const header = shell?.querySelector<HTMLElement>('.study-app-bar, :scope > header');
    setTarget(shell ?? lab ?? document.body);
    const measure = () => {
      const bounds = shell?.getBoundingClientRect();
      const next = {
        '--tool-tutor-top': `${Math.max(12, (header?.getBoundingClientRect().bottom ?? lab?.getBoundingClientRect().top ?? 0) + 12)}px`,
        '--tool-tutor-right': `${Math.max(16, window.innerWidth - (bounds?.right ?? window.innerWidth) + 16)}px`,
        '--tool-tutor-bottom': `${Math.max(16, window.innerHeight - (bounds?.bottom ?? window.innerHeight) + 16)}px`,
      } as CSSProperties;
      setStyle((previous) => (JSON.stringify(previous) === JSON.stringify(next) ? previous : next));
    };
    measure();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    if (shell) observer?.observe(shell);
    if (header) observer?.observe(header);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [host, open]);
  return { target, style };
}
